import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { FormsModule } from "@angular/forms"

import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { NgSelectModule } from "@ng-select/ng-select"
import { SharedComponentsModule } from "../../shared-components/shared-components.module"
import { CollectionSearchResultGroupComponent } from "./collection-search-result-group/collection-search-result-group.component"
import { SearchBarComponent } from "./search-bar/search-bar.component"
import { SearchCollectionInputComponent } from "./search-bar/search-collection-input/search-collection-input.component"
import { SearchCollectionPageComponent } from "./search-collection-page.component"
import { RouterModule } from "@angular/router"

@NgModule({
    declarations: [
        SearchCollectionPageComponent,
        SearchBarComponent,
        SearchCollectionInputComponent,
        CollectionSearchResultGroupComponent,
    ],
    imports: [
        CommonModule,
        SharedComponentsModule,
        NgbModule,
        FormsModule,
        NgSelectModule,
        RouterModule,
    ],
    exports: [
        SearchCollectionPageComponent,
        SearchBarComponent,
        SearchCollectionInputComponent,
        CollectionSearchResultGroupComponent,
    ],
})
export class SearchCollectionPageModule {}
